export default __webpack_public_path__ + "static/media/CardImage2.7e207952.png";